import { Instacart_Retailer_Tools_V2_InsightsPortalSchema } from '../../api'
import { type createSchemaConfig } from '../helpers/schema.helpers'
import { schemaConfig as orderDeliverySchemaConfig } from '../order-delivery'
import { schemaConfig as orderItemSchemaConfig } from '../order-item'
import { schemaConfig as searchTermSchemaConfig } from '../search-term'
import { schemaConfig as imageCoverageSchemaConfig } from '../image-coverage'
import { schemaConfig as searchTermStitchSearchTermByTermBenchmarkSchemaConfig } from '../search-term-stitch-search-term-by-term-benchmark'
import { schemaConfig as orderItemStitchProductByCategoryBenchmarkSchemaConfig } from '../order-item-stitch-product-by-category-benchmark'
import { schemaConfig as factCampaignPerformanceStitchOrderDeliverySchemaConfig } from '../fact-campaign-performance-stitch-order-delivery'
import { schemaConfig as factCampaignPerformanceStitchFactCampaignImpressionsPerformanceSchemaConfig } from '../fact-campaign-performance-stitch-fact-campaign-impressions-performance'
import { schemaConfig as aggMerchCollectionsRollupSchemaConfig } from '../agg-merch-collections-rollup'
import { schemaConfig as aggMerchFlyersSchemaConfig } from '../agg-merch-flyers'
import { schemaConfig as aggMerchPlacementsSchemaConfig } from '../agg-merch-placements'
import { schemaConfig as missingImage90DayRetailerInsightsSchemaConfig } from '../missing-image-90-day-retailer-insights'
import { schemaConfig as aggWarehouseLocationPerformanceSchemaConfig } from '../agg-warehouse-location-performance'
import { schemaConfig as factCampaignPerformanceSchemaConfig } from '../fact-campaign-performance'
import { schemaConfig as adsDisplaySchemaConfig } from '../ads-display'
import { schemaConfig as adsDisplayBannerSchemaConfig } from '../ads-display-banner'
import { schemaConfig as futureScheduledOrdersSchemaConfig } from '../future-scheduled-orders'
import { schemaConfig as pickupWarehouseLocationSchemaConfig } from '../pickup-warehouse-location'
import { schemaConfig as aggAwarenessCampaignsSchemaConfig } from '../agg-awareness-campaigns'
import { schemaConfig as aggAwarenessCampaignsStitchOrderDeliverySchemaConfig } from '../agg-awareness-campaigns-stitch-order-delivery'
import { schemaConfig as adsSponsoredProductV2SchemaConfig } from '../ads-sponsored-product-v2'
import { schemaConfig as adsOverviewSchemaConfig } from '../ads-overview'
import { schemaConfig as cancelledOrdersSchemaConfig } from '../cancelled-orders'
import { schemaConfig as caperSessionPerformanceSchemaConfig } from '../caper-session-performance'

/*
  Each individual file in this directory corresponds to the configuration for a specific schema used to build
  insights widgets. This makes it easier for engineers to work with the schema they are interested in, as
  configuration specifics are clearly encapsulated in their respective files.

  All these configuration files are exported through an index file.
*/
export const insightsSchemaConfigsV2: Partial<
  Record<Instacart_Retailer_Tools_V2_InsightsPortalSchema, ReturnType<typeof createSchemaConfig>>
> = {
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.AdsDisplay]: adsDisplaySchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.AdsDisplayBanner]: adsDisplayBannerSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.AdsOverview]: adsOverviewSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.AdsSponsoredProductV2]:
    adsSponsoredProductV2SchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.AggMerchCollectionsRollup]:
    aggMerchCollectionsRollupSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.AggMerchFlyers]: aggMerchFlyersSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.AggMerchPlacements]:
    aggMerchPlacementsSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.AggWarehouseLocationPerformance]:
    aggWarehouseLocationPerformanceSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.FactCampaignPerformance]:
    factCampaignPerformanceSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.FactCampaignPerformanceStitchFactCampaignImpressionsPerformance]:
    factCampaignPerformanceStitchFactCampaignImpressionsPerformanceSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.FactCampaignPerformanceStitchOrderDelivery]:
    factCampaignPerformanceStitchOrderDeliverySchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.ImageCoverage]: imageCoverageSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.MissingImage_90DayRetailerInsights]:
    missingImage90DayRetailerInsightsSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.OrderDelivery]: orderDeliverySchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.OrderItem]: orderItemSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.OrderItemStitchProductByCategoryBenchmark]:
    orderItemStitchProductByCategoryBenchmarkSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.SearchTerm]: searchTermSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.SearchTermStitchSearchTermByTermBenchmark]:
    searchTermStitchSearchTermByTermBenchmarkSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.PickupWarehouseLocation]:
    pickupWarehouseLocationSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.FutureScheduledOrders]:
    futureScheduledOrdersSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.AggAwarenessCampaigns]:
    aggAwarenessCampaignsSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.AggAwarenessCampaignsStitchOrderDelivery]:
    aggAwarenessCampaignsStitchOrderDeliverySchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.CancelledOrders]: cancelledOrdersSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.FactCaperSessionPerformance]:
    caperSessionPerformanceSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.FactCaperSessionPerformanceAuditPerformance]:
    caperSessionPerformanceSchemaConfig,
  [Instacart_Retailer_Tools_V2_InsightsPortalSchema.FactCaperSessionPerformanceCartOperations]:
    caperSessionPerformanceSchemaConfig,
}

export type InsightsSchemaConfigsV2 = typeof insightsSchemaConfigsV2
